import React, { type FC } from 'react';
import { FlexBox, Text } from '@is24at/react-ui-core';
import { Link } from '../Link';
import styles from './SEOLinks.scss';

export const SEOLinks: FC = () => (
  <section className={styles.container}>
    <div className={styles.grid}>
      <FlexBox alignItems="flex-start" direction="column" spacing={24}>
        <FlexBox alignItems="flex-start" direction="column" spacing={16}>
          <Text tag="h3" size="m">
            Mieten
          </Text>
          <Link href="/regional/oesterreich/wohnung-mieten">Mietwohnungen</Link>
          <Link href="/regional/oesterreich/haus-mieten">Häuser zur Miete</Link>
        </FlexBox>
        <FlexBox alignItems="flex-start" direction="column" spacing={16}>
          <Text tag="h3" size="m">
            Kaufen
          </Text>
          <Link href="/regional/oesterreich/wohnung-kaufen">
            Eigentumswohnungen
          </Link>
          <Link href="/regional/oesterreich/haus-kaufen">Häuser zum Kauf</Link>
        </FlexBox>
        <FlexBox alignItems="flex-start" direction="column" spacing={16}>
          <Text tag="h3" size="m">
            Gewerbe
          </Text>
          <Link href="/regional/oesterreich/bueros">Büroimmobilien</Link>
          <Link href="/regional/oesterreich/geschaeftslokale">
            Einzelhandelsimmobilien
          </Link>
          <Link href="/regional/oesterreich/industrieanlagen">
            Industrieimmobilien
          </Link>
        </FlexBox>
      </FlexBox>
      <FlexBox alignItems="flex-start" direction="column" spacing={16}>
        <Text tag="h3" size="m">
          Beliebte Immobilientypen
        </Text>
        <Link href="/wohnen/apartments.html">Apartment</Link>
        <Link href="/gewerbe/bauernhof.html">Bauernhof</Link>
        <Link href="/wohnen/blockhaeuser.html">Blockhaus</Link>
        <Link href="/wohnen/bungalows.html">Bungalow</Link>
        <Link href="/wohnen/energiesparhaeuser.html">Energiesparhaus</Link>
        <Link href="/wohnen/fertighaeuser.html">Fertighaus</Link>
        <Link href="/wohnen/haeuser-am-see.html">Haus am See</Link>
        <Link href="/wohnen/holzhaeuser.html">Holzhaus</Link>
        <Link href="/wohnen/lofts.html">Loft</Link>
        <Link href="/wohnen/moderne-haeuser.html">Modernes Haus</Link>
        <Link href="/wohnen/villen.html">Villa</Link>
      </FlexBox>
      <FlexBox alignItems="flex-start" direction="column" spacing={16}>
        <Text tag="h3" size="m">
          Immobilien in Österreichs Bundesländern
        </Text>
        <Link href="/regional/burgenland/immobilien">Burgenland</Link>
        <Link href="/regional/kaernten/immobilien">Kärnten</Link>
        <Link href="/regional/niederoesterreich/immobilien">
          Niederösterreich
        </Link>
        <Link href="/regional/oberoesterreich/immobilien">Oberösterreich</Link>
        <Link href="/regional/salzburg/immobilien">Salzburg</Link>
        <Link href="/regional/steiermark/immobilien">Steiermark</Link>
        <Link href="/regional/tirol/immobilien">Tirol</Link>
        <Link href="/regional/vorarlberg/immobilien">Vorarlberg</Link>
        <Link href="/regional/wien/wien/immobilien">Wien</Link>
      </FlexBox>
      <FlexBox alignItems="flex-start" direction="column" spacing={16}>
        <Text tag="h3" size="m">
          Beliebteste Städte
        </Text>
        <Link href="/regional/niederoesterreich/baden/immobilien">Baden</Link>
        <Link href="/regional/steiermark/graz/immobilien">Graz</Link>
        <Link href="/regional/tirol/innsbruck/immobilien">Innsbruck</Link>
        <Link href="/regional/tirol/kitzbuehel/immobilien">Kitzbühel</Link>
        <Link href="/regional/kaernten/klagenfurt-am-woerthersee/immobilien">
          Klagenfurt
        </Link>
        <Link href="/regional/oberoesterreich/linz/immobilien">Linz</Link>
        <Link href="/regional/niederoesterreich/moedling/immobilien">
          Mödling
        </Link>
        <Link href="/regional/salzburg/salzburg/immobilien">Salzburg</Link>
        <Link href="/regional/wien/wien/wohnung-mieten">Wien</Link>
        <Link href="/regional/salzburg/zell-am-see/immobilien">
          Zell am See
        </Link>
      </FlexBox>
      <FlexBox alignItems="flex-start" direction="column" spacing={16}>
        <Text tag="h3" size="m">
          Immobilienthemen
        </Text>
        <Link href="/baulexikon/">Bauen</Link>
        <Link href="/eigentuemerlexikon/">Eigentümer</Link>
        <Link href="/wissen/finanzierung.html">Finanzen</Link>
        <Link href="/ratgeber/umzug/">Umzug Ratgeber</Link>
        <Link href="/wissen/vermieten.html">Wissen Vermieten</Link>
        <Link href="/wissen/verkaufen.html">Wissen Verkaufen</Link>
      </FlexBox>
    </div>
  </section>
);
